import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import FlowService from '../../services/flow-service';

// Flow 391 is the 'nhs' slug flow — stable across environments
const NHS_FLOW_ID = 391;

const CreateAccountPreFlow: React.FC = () => {
  const { search } = useLocation();

  useEffect(() => {
    // No origin rewrite here: the create-account flow (and its Auth0 callback + the mobile
    // handoff) stay on whichever origin they started on. buildCanonicalRedirectUri() uses the
    // current origin, which Auth0 already allows, so localStorage / the sl-user-flow cookie /
    // the sessionStorage redirect_url all remain visible across the round-trip.
    const params = new URLSearchParams(search);
    const redirectUrl = params.get('redirect_url') ?? '';

    // Pre-warm the Country Selector step for all users (authenticated or not).
    // On iOS, WKWebViews share the cookie store — an already-authenticated user
    // opening this in-app browser is still redirected cross-domain by
    // redirectUserToAppropriateFlow, which iOS native intercepts, leaving the
    // WebView alive with a Loader. The '?create_account=1' flag signals
    // flow.container to show the Country Selector after a 100 ms fallback timer
    // in that case. 'sl-flow-progress' (FlowService) is a different localStorage
    // key from 'sl-answers' (AnswersService), so removeAnswers() inside
    // redirectUserToAppropriateFlow does not erase this pre-warm.
    FlowService.setLocalProgress(NHS_FLOW_ID, 1, 0);
    const caQs = `?create_account=1${
      redirectUrl ? `&redirect_url=${encodeURIComponent(redirectUrl)}` : ''
    }`;
    window.location.replace(`/sleepio/nhs${caQs}`);
  }, [search]);

  return null;
};

export default CreateAccountPreFlow;
